import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Close = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '25',
    defaultHeight: '25',
    defaultColorDarkMode: 'primary/text',
    defaultColorLightMode: 'primary/text',
    style,
  });

  return (
    <svg
      width={widthToUse}
      height={heightToUse}
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 25 25'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.35539 5.66484C5.74592 5.27432 6.37908 5.27432 6.76961 5.66484L12.0625 10.9577L17.3554 5.66484C17.7459 5.27432 18.3791 5.27432 18.7696 5.66484C19.1601 6.05537 19.1601 6.68853 18.7696 7.07906L13.4767 12.3719L18.7696 17.6648C19.1601 18.0554 19.1601 18.6885 18.7696 19.0791C18.3791 19.4696 17.7459 19.4696 17.3554 19.0791L12.0625 13.7862L6.76961 19.0791C6.37908 19.4696 5.74592 19.4696 5.35539 19.0791C4.96487 18.6885 4.96487 18.0554 5.35539 17.6648L10.6483 12.3719L5.35539 7.07906C4.96487 6.68853 4.96487 6.05537 5.35539 5.66484Z'
        fill={primaryColorToUse}
      />
    </svg>
  );
};

export default Close;
